import React, { MouseEvent, ReactElement } from 'react';
import classNames from 'classnames';
import { BadgeBackground } from 'types/types';
import Badge from 'components/badge/Badge';
import CardIcon, { CardIconType } from 'components/card/CardIcon';
import styles from './Card.module.scss';

interface Props {
    children?: React.ReactChild;
    classNameBadge?: string;
    className?: string;
    classNameCardIcon?: string;
    onClick?: (e: MouseEvent<HTMLElement>) => void;
    badge?: {
        background: BadgeBackground;
        icon: React.FC<React.SVGProps<SVGSVGElement>>;
    };
    action?: CardIconType;
}

const Card = ({
    children,
    className,
    classNameBadge,
    badge,
    action,
    classNameCardIcon,
    onClick,
}: Props): ReactElement => {
    return (
        <div className={classNames(className, styles.root)} onClick={onClick}>
            {badge && (
                <Badge
                    background={badge.background}
                    icon={badge.icon}
                    className={classNames(styles.badge, classNameBadge)}
                />
            )}
            {action && (
                <CardIcon action={action} className={classNameCardIcon} />
            )}
            {children}
        </div>
    );
};

export default Card;
